<template>
  <header class="app-header">
    <slot />
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
}
</script>

<style lang="scss" scoped>
.app-header {
  display: flex;
  align-items: center;

  > h1,
  > h2,
  > h3,
  > h4,
  > h5 {
    margin-top: 0;
    margin-bottom: 0;
  }

  > * {
    margin-left: 1em;

    &:first-child {
      margin-left: 0;
    }
  }
}
</style>
